import { ApiBase } from './ApiBase';
class UserApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getUserConnections = () => {
            return this.get('/user/v2/connections');
        };
        this.updateUserAccountSettings = (payload) => {
            return this.put('/user/account-settings', payload);
        };
    }
}
export const UserApiClient = new UserApiClientModel();
